"use client";
import Link from "next/link";
import { Typography } from "@/components/ui/typography";
import Icon from "@/components/ui/Icon";
import { LanguageButtonLink } from "@/components/screen/global-components/language";

type LanguageBlockProps = {
  content: {
    title: string;
    description: string;
    languages: {
      name: string;
      link?: string;
    }[];
    exploreText: string;
  };
};

export default function LanguageBlock({ content }: LanguageBlockProps) {
  return (
    <section className="section bg-[#f7f7f9]">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="grid grid-cols-1 gap-6 md:flex md:items-start md:gap-[min(3rem,3.33vw)]">
          <div className="grid grid-cols-1 gap-4 md:gap-8 w-full md:min-w-[280] md:max-w-[50%] lg:max-w-[436]">
            <Typography variant="heading4" className="lg:leading-[136%]">
              <h2>{content.title}</h2>
            </Typography>
            <Typography
              variant="subHeadingSm"
              className="text-gray-600"
              asChild
            >
              <p>{content.description}</p>
            </Typography>
          </div>
          <div className="grid grid-cols-1 gap-4 flex-auto min-w-0">
            <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
              {content.languages.map(({ name, link }, index) => {
                return (
                  <LanguageButtonLink href={link} key={index}>
                    {name}
                  </LanguageButtonLink>
                );
              })}
              <Link
                href="/languages"
                className="flex not-even:col-span-2 lg:not-even:col-span-1"
              >
                <span className="flex-auto min-w-0 flex group rounded-2xl border-1 bg-white items-center justify-between py-5 px-6 md:py-3 cursor-pointer text-gray-500 text-lg leading-[130%] md:py-4 md:text-xl md:leading-[150%] border-[#BAD5F9] hover:text-[#4381E5] hover:border-[#4381E5]">
                  <span>{content.exploreText}</span>
                  <Icon
                    id="icon-arrow-right_24"
                    width={24}
                    height={24}
                    className="shrink-0 w-6 h-6 ml-2"
                  />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
